var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.direction === "left"
    ? _c(
        "svg",
        {
          attrs: {
            width: _vm.width,
            height: _vm.height,
            viewBox: _vm.viewBox,
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
          },
        },
        [
          _c("title", [_vm._v("Arrow Left")]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: { transform: "translate(-359.000000, -1457.000000)" },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(359.000000, 1457.000000)",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          stroke: "#F1E6B2",
                          "stroke-width": "2",
                          cx: "30",
                          cy: "30",
                          r: "29",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M27.7071068,23.2928932 L33.3455714,28.9291741 C33.3517588,28.9350572 33.3578895,28.9410348 33.3639615,28.9471068 C33.5141631,29.0973084 33.6065949,29.2834037 33.6412568,29.4777821 C33.6967155,29.7914282 33.6042837,30.1236384 33.363961,30.363961 L33.344,30.38 L27.7071072,36.0181746 C27.3165829,36.4086989 26.6834179,36.4086989 26.2928937,36.0181746 C25.9023694,35.6276503 25.9023694,34.9944853 26.2928937,34.603961 L31.241,29.655 L26.2928932,24.7071068 C25.9023689,24.3165825 25.9023689,23.6834175 26.2928932,23.2928932 C26.6834175,22.9023689 27.3165825,22.9023689 27.7071068,23.2928932 Z",
                          id: "Combined-Shape-Copy-2",
                          fill: "#880D27",
                          transform:
                            "translate(29.828427, 29.655534) scale(-1, 1) translate(-29.828427, -29.655534) ",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _c(
        "svg",
        {
          attrs: {
            width: _vm.width,
            height: _vm.height,
            viewBox: _vm.viewBox,
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
          },
        },
        [
          _c("title", [_vm._v("Arrow Right")]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: { transform: "translate(-1500.000000, -1459.000000)" },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(1500.000000, 1459.000000)",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          stroke: "#F1E6B2",
                          "stroke-width": "2",
                          transform:
                            "translate(30.000000, 30.000000) scale(-1, 1) translate(-30.000000, -30.000000) ",
                          cx: "30",
                          cy: "30",
                          r: "29",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M27.7071068,23.2928932 L33.3455714,28.9291741 C33.3517588,28.9350572 33.3578895,28.9410348 33.3639615,28.9471068 C33.5141631,29.0973084 33.6065949,29.2834037 33.6412568,29.4777821 C33.6967155,29.7914282 33.6042837,30.1236384 33.363961,30.363961 L33.344,30.38 L27.7071072,36.0181746 C27.3165829,36.4086989 26.6834179,36.4086989 26.2928937,36.0181746 C25.9023694,35.6276503 25.9023694,34.9944853 26.2928937,34.603961 L31.241,29.655 L26.2928932,24.7071068 C25.9023689,24.3165825 25.9023689,23.6834175 26.2928932,23.2928932 C26.6834175,22.9023689 27.3165825,22.9023689 27.7071068,23.2928932 Z",
                          id: "Combined-Shape-Copy-2",
                          fill: "#880D27",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }